module.exports = __webpack_public_path__ + "img/3.cc6b187b.jpg";